import { render, staticRenderFns } from "./VacationsGroupFormPage.vue?vue&type=template&id=6e3fc5df&"
import script from "./VacationsGroupFormPage.vue?vue&type=script&lang=js&"
export * from "./VacationsGroupFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports